import { createSlice } from "@reduxjs/toolkit";
import { TimeService } from "../services/TimeService";

export type SettingModel = { SettingName: string; Value: string };

type SettingsMap = {
	[key: string]: any;
};
const UTLSettingsInitialState: {
	serverTimeZone: string;
	settings: SettingsMap;
} = {
	serverTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	settings: {},
};

export const UTLSettingsReducer = createSlice({
	name: "__",
	initialState: UTLSettingsInitialState,
	reducers: {
		setServerTimeZone(state, { payload }) {
			state.serverTimeZone = payload;
		},
		setSetting(state, { payload }) {
			state.settings[payload.key] = payload.value;
		},
		initSettings(state, { payload }) {
			state.settings = (payload as SettingModel[]).reduce((acc, cur) => {
				if (cur.SettingName.trim() === "TimeZone") {
					const timeService: TimeService = TimeService.getInstance();
					timeService.setTimeZone(cur.Value);
				}

				acc[cur.SettingName.trim()] = cur.Value;
				return acc;
			}, {} as SettingsMap);
		},
	},
});
